var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReset(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_9549",
    "data-name": "Group 9549",
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.236,
    height: 18.051,
    viewBox: "0 0 21.236 18.051",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Revert",
    transform: "translate(-1924.002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Component_125_76",
    "data-name": "Component 125 \\u2013 76",
    transform: "translate(1924.002 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4301",
    "data-name": "Path 4301",
    d: "M-266,54l3.81,6.3,3.623-6.3Zm3.787,4.21-1.9-3.148h3.713Z",
    transform: "translate(266 -48.629)",
    fill: "#998242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4302",
    "data-name": "Path 4302",
    d: "M-254.022,48a9.015,9.015,0,0,0-7.645,4.247,7.865,7.865,0,0,0-.573,1.062h1.189a6.87,6.87,0,0,1,.669-1.062,7.943,7.943,0,0,1,6.36-3.185,7.966,7.966,0,0,1,7.964,7.964,7.966,7.966,0,0,1-7.964,7.964,7.874,7.874,0,0,1-6.488-3.377l-.584,1.009a8.992,8.992,0,0,0,7.072,3.43A9.031,9.031,0,0,0-245,57.025,9.031,9.031,0,0,0-254.022,48Z",
    transform: "translate(266.232 -48)",
    fill: "#998242"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReset);
export default __webpack_public_path__ + "static/media/reset.187fc2b73b7515c7a7a7c8a64f4482ce.svg";
export { ForwardRef as ReactComponent };